import { graphql } from 'src/gql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query lookupOptions($key: String!) {
    lookups {
      all(key: $key) {
        _id
        abbreviation
        archived
        color
        createdAt
        name
        oldOrder
        order
        status
        updatedAt
        relationships {
          model
          label
          count
        }
        _createdBy {
          name
        } 
        _updatedBy {
          name
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type LookupOptions = NonNullable<NonNullable<NonNullable<TData>['lookups']>['all']>

const useLookupOptions = (key: string): LookupOptions => {
  const { data } = useGraphQL(document, { key }, {
    enabled: typeof key === 'string'
  })
  return data?.lookups?.all ?? []
}

export { useLookupOptions, document as lookupOptionsDocument }
